// extracted by mini-css-extract-plugin
module.exports = {"base":"Breadcrumbs_base__1WzQT"};